<t-llevo-dialog-header
  mat-dialog-title
  dialogTitle="Editar Conductor"
></t-llevo-dialog-header>

<mat-dialog-content>
  <mat-accordion multi="true" commonui-loader [appLoader]="loading() ?? false">
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Personal </mat-panel-title>
      </mat-expansion-panel-header>

      <t-llevo-edit-personal-form [frm]="personal"></t-llevo-edit-personal-form>
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Licencia </mat-panel-title>
      </mat-expansion-panel-header>

      <t-llevo-edit-licenses-form [frm]="licenses"></t-llevo-edit-licenses-form>
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Vehículo </mat-panel-title>
      </mat-expansion-panel-header>

      <t-llevo-edit-vehicle-form [frm]="vehicle"></t-llevo-edit-vehicle-form>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    (click)="onSumbit()"
    [disabled]="frm.invalid || frm.pristine"
    color="accent"
  >
    Guardar cambios
  </button>
</mat-dialog-actions>
